/**
 * Sub sample
 *
 * @group ISOBMFF
 *
 * @beta
 */
export type Subsample = {
	subsampleSize: number;
	subsamplePriority: number;
	discardable: number;
	codecSpecificParameters: number;
};
